//import { AxiosRequestHeaders } from "axios";
import sequenceInstance from "contexts/SessionSequenceProvider";
import { LOCAL_STORAGE_TIME_ZONE } from "debug/components/SetLocalTime";

import { AuthToken } from "interfaces";
import { selectWebStoreState } from "redux/slices";
import { RootState } from "redux/store";
import { analyticsTrackerV2 } from "contexts/ScopelyIdentityProvider/configv2";
import { getLocalDateEtcGMTFormat } from "utils/time";
import { getIsStandalonePWA } from "components/PWA/helpers/getIsStandalonePWA";
import { getPlatform } from "utils/platform";

/* export const convertToAxiosHeaders = (
	pHeaders: Headers
): AxiosRequestHeaders => {
	const axiosHeaders: AxiosRequestHeaders = {};

	pHeaders.forEach((value, key) => {
		axiosHeaders[key] = value;
	});

	return axiosHeaders;
}; */

export const headersConfig = (
	pHeaders?: Headers,
	getState?: () => RootState
): Headers => {
	const state = getState?.() as RootState;
	const { sessionId } = selectWebStoreState(state);

	let headers = new Headers();
	if (pHeaders) {
		headers = pHeaders;
	}

	headers.set("Content-Type", "application/json");
	headers.set(
		"X-SCOPELY-WEBSTORE-SESSION-REQUEST-SEQUENCE",
		sequenceInstance.incrementAndGetSequence().toString()
	);
	headers.set("X-SCOPELY-WEBSTORE-SESSION-ID", sessionId);
	headers.set(
		"X-SCOPELY-WEBSTORE-LAUNCH-SOURCE",
		getIsStandalonePWA() ? "pwa" : "web"
	);

	const authToken = localStorage.getItem(
		"store.solitairetripeaks.com:authToken"
	);
	const token = authToken ? JSON.parse(authToken) : null;
	if (token) {
		headers.set("authorization", `Bearer ${(token as AuthToken).value}`);
	}
	const namespaceOverride = localStorage.getItem(
		"store.solitairetripeaks.com:namespaceOverride"
	);
	const parsedNameSpaceOverride = namespaceOverride
		? JSON.parse(namespaceOverride)
		: null;

	if (parsedNameSpaceOverride) {
		headers.set("X-GSN-WEBSTORE-NAMESPACE-OVERRIDE", parsedNameSpaceOverride);
	}

	const syntheticId = localStorage.getItem(
		"store.solitairetripeaks.com:syntheticId"
	);
	const parsedSyntheticId = syntheticId ? JSON.parse(syntheticId) : null;
	if (parsedSyntheticId) {
		headers.set("X-GSN-WEBSTORE-SYNTHETIC-ID", parsedSyntheticId);
	}
	const platform = getPlatform();
	headers.set("X-SCOPELY-WEBSTORE-PLATFORM", platform);
	const deviceToken = analyticsTrackerV2.getDeviceToken();
	if (deviceToken) {
		headers.set("X-TITAN-DEVICE-TOKEN", deviceToken);
	}
	const titanMetadataHeader = JSON.stringify({
		app_version: process.env.REACT_APP_WEBSTORE_RELEASE_VERSION,
		environment_id: process.env.REACT_APP_SCOPELY_ANALYTICS_ENVIRONMENT_ID
	});
	headers.set("X-TITAN-METADATA", titanMetadataHeader);

	const localTimeZoneOverride = localStorage.getItem(LOCAL_STORAGE_TIME_ZONE);
	headers.set(
		"X-GSN-WEBSTORE-REFERER-TIMEZONE",
		localTimeZoneOverride ? localTimeZoneOverride : getLocalDateEtcGMTFormat()
	);

	return headers;
};
